var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8178 1.52317C26.7405 -0.280161 23.1627 1.42949 23.6738 4.94248C23.8829 6.37109 24.4637 7.12053 27.9718 10.3876C42.7941 24.2288 48.1027 30.3999 55.2698 42.1099C57.9532 46.5011 59.2542 47.5199 59.231 45.2247C59.2077 42.6485 56.5476 34.2291 54.1663 29.1587C48.1027 16.2777 38.4961 4.90735 30.8178 1.52317Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51992 64.9322C-0.0694802 67.5786 -0.40635 71.5483 2.86941 72.8715C4.20527 73.4102 5.13457 73.2696 9.69972 71.8644C29.029 65.9041 36.9745 64.3818 50.6235 64.0305C55.7346 63.9017 57.2564 63.281 55.2816 62.1452C53.0629 60.8688 44.5018 58.9484 38.9493 58.48C24.8588 57.2856 10.2805 59.9437 3.51992 64.9322Z",
    fill: "#FFC41E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43544 36.2671C2.13745 37.4263 0.406644 41.0096 2.97382 43.4336C4.01928 44.4172 4.93695 44.628 9.7112 44.991C29.8653 46.4899 37.834 47.9653 50.6698 52.6024C55.4906 54.3472 57.1284 54.3238 55.688 52.5439C54.0734 50.5532 46.7784 45.635 41.7835 43.1759C29.0754 36.9228 14.5319 34.0773 6.43544 36.2671Z",
    fill: "#00BF9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_1112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.6269,
    height: 72.3675,
    fill: "white",
    transform: "translate(0.604492 0.796875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector-2.7323daf12d28a5940571f1b8b86e81d9.svg";
export { ForwardRef as ReactComponent };